
import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'application-dashboard'
const initialState = {
    list: null,
    stats: null,
}
export const search = createApiAction('application-dashboard/get', client.retrieve('/api/application/dashboard'))

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
        .addCase(search.fulfilled, (state, action) => {
            state.list = action.payload.schoolApplications
            state.stats = action.payload.stats
        })
  },
})

export default sessionSlice.reducer